// Özel kullanıcı ID'leri listesi
// Bu ID'ler için özel işlemler yapılır (otomatik gümrükleme seçimi yapılmaz, vb.)
export const SPECIAL_USER_IDS = ["4000000003", 4000000003, "100004580", 100004580, "100003249", 100003249, "4000001192", 4000001192, "4000000338", 4000000338];

// DDP Teminat Bedeli gösterilecek kullanıcı ID'leri
export const DDP_BALANCE_USER_IDS = ["4000000003", 4000000003, "100004580", 100004580, "100005054", 100005054, "4000000004", 4000000004, "100000917", 100000917, "100003029", 100003029];

// DDP Teminat Bedeli'ni dolar cinsinden gösterecek kullanıcı ID'leri
export const DDP_BALANCE_USD_USER_IDS = ["100005054", 100005054, "4000000004", 4000000004, "100000917", 100000917, "100003029", 100003029];

// Kullanıcının permission_type: "1" iznine sahip olup olmadığını kontrol eden fonksiyon
export const hasPermissionType1 = () => {
  try {
    const userStr = localStorage.getItem("user");
    if (!userStr) return false;
    
    const userObj = JSON.parse(userStr);
    const permissions = userObj?.user?.user_member?.get_member_specific_permission;
    
    if (!Array.isArray(permissions)) return false;
    
    return permissions.some(permission => 
      permission?.permission_type === "1" || Number(permission?.permission_type) === 1
    );
  } catch (error) {
    console.error("Error checking permission_type 1:", error);
    return false;
  }
};

// Kullanıcının permission_type: "2" iznine sahip olup olmadığını kontrol eden fonksiyon
export const hasPermissionType2 = () => {
  try {
    const userStr = localStorage.getItem("user");
    if (!userStr) return false;
    
    const userObj = JSON.parse(userStr);
    const permissions = userObj?.user?.user_member?.get_member_specific_permission;
    
    if (!Array.isArray(permissions)) return false;
    
    return permissions.some(permission => 
      permission?.permission_type === "2" || Number(permission?.permission_type) === 2
    );
  } catch (error) {
    console.error("Error checking permission_type 2:", error);
    return false;
  }
};

// Kullanıcının permission_type: "1" veya "2" iznine sahip olup olmadığını kontrol eden fonksiyon
export const hasPermissionType1Or2 = () => {
  return hasPermissionType1() || hasPermissionType2();
};

// Supplier filtreleme - Yetki bazlı görünürlük kontrolü
// YETKİLİ kullanıcılar (permission 1 veya 2 OLAN): 1342, 1343, 1350 GİZLİ - 342, 343, 350 GÖRÜNÜR
// YETKİSİZ kullanıcılar (permission 1 veya 2 OLMAYAN): 342, 343, 350 GİZLİ - 1342, 1343, 1350 GÖRÜNÜR
export const shouldHideSupplier = (supplierId) => {
  const hasPermission = hasPermissionType1Or2();
  
  // Yetkili kullanıcılar için 1342, 1350, 1343 gizle
  if (hasPermission) {
    const restrictedForAuthorized = [1342, 1350, 1343, "1342", "1350", "1343"];
    return restrictedForAuthorized.includes(supplierId);
  }
  
  // Yetkisiz kullanıcılar için 342, 350, 343 gizle
  const restrictedForUnauthorized = [342, 350, "342", "350"];
  return restrictedForUnauthorized.includes(supplierId);
};

// Kullanıcının özel kullanıcı olup olmadığını kontrol eden yardımcı fonksiyon
// Hem SPECIAL_USER_IDS listesinde olup olmadığını hem de permission_type: "2" iznine sahip olup olmadığını kontrol eder
export const isSpecialUser = (userId) => {
  const isInSpecialList = SPECIAL_USER_IDS.includes(userId);
  const hasPermission2 = hasPermissionType2();
  return isInSpecialList || hasPermission2;
};

// Kullanıcıya DDP teminat bedeli gösterilip gösterilmeyeceğini kontrol eden fonksiyon
export const shouldShowDdpBalance = (userId) => {
  return DDP_BALANCE_USER_IDS.includes(userId);
};

